import { createComponent } from '@carvana/merch-components';

export const wrapperStyles =
  '@container relative flex overflow-hidden mb-2xl rounded-md sm:mb-3xl lg:rounded-xl';

export const Wrapper = createComponent('div', {
  className: wrapperStyles
});

export const LeftContent = createComponent('div', {
  className: `
    relative z-1 flex flex-col items-start justify-center gap-lg
    min-w-[180px] max-w-[65%]
    sm:max-w-[50%]
    lg:max-w-[400px]
    xl:max-w-[50%]
    py-2xl pl-2xl
    lg:py-4xl lg:pl-4xl
  `
});

export const TradeIncentiveLeftContent = createComponent('div', {
  className: `
    relative z-10 flex flex-col items-start justify-center gap-lg
    min-w-0
    flex-[2_1_0%]
    max-w-[calc(100%-120px)]
    sm:max-w-[50%]
    @min-[700px]:max-w-[600px]
    py-2xl pl-2xl
    @min-[900px]:py-4xl @min-[900px]:pl-4xl
  `
});

export const TitleWrapper = createComponent('h4', {
  className: `
    t-heading-sm
    sm:t-heading-xl
    lg:t-heading-2xl
    u:text-text-strong
  `
});

export const TradeIncentiveTitleWrapper = createComponent('h4', {
  className: `
    @min-[900px]:flex
    @min-[900px]:flex-col
    gap-md
    min-w-0
    t-heading-sm
    @min-[700px]:t-heading-xl
    @min-[900px]:t-heading-2xl
    u:text-text-strong
  `
});

export const TradeIncentiveRightContent = createComponent('div', {
  className: `
    relative
    flex-[1_1_0%]
    max-w-[480px]
  `
});

export const TradeIncentiveSwooshImage = createComponent('img', {
  className: `
    absolute z-[2] h-full min-w-full
    left-[40px]
    @min-[700px]:left-[40px]
    @min-[900px]:left-[40px]
  `
});

export const TradeIncentiveCarImage = createComponent('img', {
  className: `
    absolute z-[3]
    left-0
    @min-[700px]:-left-[40px]
    top-1/2 -translate-y-1/2
    min-w-[300px]
    w-[300px]
    @min-[900px]:w-[360px]
  `
});
